module.exports = __webpack_public_path__ + "static/media/openai.24872d8f.png";